import { Link } from "react-router-dom";
import { useEffect, useState } from "react";
import api from "../lib/api";
import { Instagram, Twitter, Linkedin, Mail, Phone, MapPin } from "lucide-react";
import HostroLogo from "./HostroLogo";

export default function Footer() {
  const [c, setC] = useState(null);
  useEffect(() => { api.get("/company").then(r => setC(r.data)).catch(()=>{}); }, []);

  const fullAddress = c?.address ? `${c.address.line1}, ${c.address.line2}, ${c.address.city}, ${c.address.state} ${c.address.postal}, ${c.address.country}` : "";

  return (
    <footer className="bg-[#0E1F18] text-[#FDFCF8]" data-testid="footer">
      <div className="max-w-7xl mx-auto px-5 md:px-10 py-16 grid md:grid-cols-5 gap-10">
        <div className="md:col-span-2">
          <HostroLogo size={40} dark/>
          <p className="mt-4 text-sm text-gray-400 max-w-xs">
            {c?.tagline || "One Platform. Endless Possibilities."} Unified digital platform for student housing — students, owners, vendors and colleges.
          </p>
          <div className="flex gap-2 mt-5">
            {c?.social?.instagram && <a className="w-9 h-9 rounded-full border border-white/20 grid place-items-center hover:bg-emerald-600 hover:border-emerald-600 transition" href={c.social.instagram} target="_blank" rel="noopener noreferrer" aria-label="instagram"><Instagram size={16}/></a>}
            {c?.social?.twitter && <a className="w-9 h-9 rounded-full border border-white/20 grid place-items-center hover:bg-emerald-600 hover:border-emerald-600 transition" href={c.social.twitter} target="_blank" rel="noopener noreferrer" aria-label="twitter"><Twitter size={16}/></a>}
            <a className="w-9 h-9 rounded-full border border-white/20 grid place-items-center hover:bg-emerald-600 hover:border-emerald-600 transition" href={c?.social?.linkedin || "#"} target="_blank" rel="noopener noreferrer" aria-label="linkedin"><Linkedin size={16}/></a>
          </div>
        </div>
        <div>
          <div className="text-xs font-bold uppercase tracking-wider text-emerald-400 mb-4">For Students</div>
          <ul className="space-y-2 text-sm">
            <li><Link to="/properties" className="text-gray-300 hover:text-emerald-400 transition">Find PG</Link></li>
            <li><Link to="/roommates" className="text-gray-300 hover:text-emerald-400 transition">Roommates</Link></li>
            <li><Link to="/student-ambassador" className="text-gray-300 hover:text-emerald-400 transition">Become an Ambassador</Link></li>
            <li><Link to="/register" className="text-gray-300 hover:text-emerald-400 transition">Create account</Link></li>
            <li><Link to="/blog" className="text-gray-300 hover:text-emerald-400 transition">Student guides</Link></li>
            <li><Link to="/faq" className="text-gray-300 hover:text-emerald-400 transition">FAQs</Link></li>
          </ul>
        </div>
        <div>
          <div className="text-xs font-bold uppercase tracking-wider text-rose-400 mb-4">For Owners</div>
          <ul className="space-y-2 text-sm">
            <li><Link to="/list-property" className="text-gray-300 hover:text-rose-400 transition">List your property</Link></li>
            <li><Link to="/register" className="text-gray-300 hover:text-rose-400 transition">Owner sign-up</Link></li>
            <li><Link to="/blog" className="text-gray-300 hover:text-rose-400 transition">Owner playbook</Link></li>
            <li><Link to="/vendors/register" className="text-gray-300 hover:text-rose-400 transition">Vendor sign-up</Link></li>
          </ul>
        </div>
        <div>
          <div className="text-xs font-bold uppercase tracking-wider text-blue-400 mb-4">Company</div>
          <ul className="space-y-2 text-sm">
            <li><Link to="/about" className="text-gray-300 hover:text-blue-400 transition">About us</Link></li>
            <li><Link to="/contact" className="text-gray-300 hover:text-blue-400 transition">Contact</Link></li>
            <li>
              <a className="text-gray-300 hover:text-blue-400 transition flex items-center gap-1.5" href={`mailto:${c?.contact?.emails?.primary || "hello@hostro.in"}`}>
                <Mail size={13}/>{c?.contact?.emails?.primary || "hello@hostro.in"}
              </a>
            </li>
            <li>
              <a className="text-gray-300 hover:text-blue-400 transition flex items-center gap-1.5" href={`tel:${(c?.contact?.phone||"").replace(/\s/g,"")}`}>
                <Phone size={13}/>{c?.contact?.phone || "+91 89052 90804"}
              </a>
            </li>
          </ul>
        </div>
      </div>

      <div className="border-t border-white/10 py-6 px-5 md:px-10 max-w-7xl mx-auto">
        {fullAddress && (
          <div className="flex items-start gap-2 text-xs text-gray-500 mb-3" data-testid="footer-address">
            <MapPin size={14} className="flex-shrink-0 mt-0.5"/>
            <span>{c?.legal_name}, {fullAddress}</span>
          </div>
        )}
        <div className="flex flex-col md:flex-row justify-between gap-2 text-xs text-gray-500">
          <div>
            © {new Date().getFullYear()} {c?.legal_name || "Hostro Ventures Private Limited"} — All rights reserved.
            {c?.cin && <span className="ml-2">· CIN: <code className="text-gray-400">{c.cin}</code></span>}
            {c?.gstin && <span className="ml-2">· GSTIN: <code className="text-gray-400">{c.gstin}</code></span>}
          </div>
          <div className="flex gap-4 flex-wrap">
            <Link to="/privacy" className="hover:text-emerald-400 transition">Privacy</Link>
            <Link to="/terms" className="hover:text-emerald-400 transition">Terms</Link>
            <Link to="/refund" className="hover:text-emerald-400 transition">Refund</Link>
            <Link to="/cancellation" className="hover:text-emerald-400 transition">Cancellation</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
